export const handleListFilters = (self) => {
	let isClear;

	showItems(self);

	// get clicks on the load more button
	self.loadMoreButton.on('click', () => {
		// get the last visible element in the matched set
		let lastVisibleItem = self.matchedItems.not('.d-none').last();
		// show the next few items
		lastVisibleItem.nextAll('[data-matched="true"]').slice(0, self.pageSize + 1).removeClass('d-none');
		// check if all matched items are shown and hide the load more button
		if(self.matchedItems.not(':visible').length === 0) {
			self.loadMoreButton.addClass('d-none');
		}
	});

	// get items on filters change
	self.filters.on('change', () => {
		if(!isClear) {
			showItems(self);
		}
	});

	// get clicks on the clear button
	self.clearButton.on('click', () => {
		self.filters.each((index, element) => {
			isClear = true;
			$(element).val($(element).find('option:first').attr('value')).change();
		});

		isClear = false;
		showItems(self);
	});
};

const showItems = (self) => {
	// resets
	self.filteredIndexes = [];
	self.listItems.addClass('d-none');
	self.listItems.attr('data-matched', false);
	self.emptyResultText.addClass('d-none');

	// loop through filters
	self.filters.each((index, element) => {
		let selectedValue = $(element).val();
		let dataStr;
		($(element).attr('id') === 'datesFilter') ? dataStr = 'dates' : dataStr = 'topics';
		self.listItems.each((index, element) => {
			if($(element).find(self.itemClassName).data(dataStr).indexOf(selectedValue) > -1) {
				self.filteredIndexes.push(index);
			}
		});
	});

	// reduce the array to duplicate items only (items matched by both filters)
	self.filteredIndexes = self.filteredIndexes.filter((a, i, aa) => aa.indexOf(a) === i && aa.lastIndexOf(a) !== i);

	// use the filtered indexes to show / hide list items
	self.listItems.each((index, element) => {
		if(self.filteredIndexes.indexOf(index) > -1) {
			$(element).removeClass('d-none');
			$(element).attr('data-matched', true);
		}
	});

	// show only the first few
	self.matchedItems = self.$element.find('[data-matched="true"]');
	self.matchedItemsCount = self.matchedItems.length;

	if(self.matchedItemsCount-1 > self.pageSize) {
		self.loadMoreButton.removeClass('d-none');
		self.matchedItems.each((index, element) => {
			if(index > self.pageSize) {
				$(element).addClass('d-none');
			}
		});
	}
	else {
		self.loadMoreButton.addClass('d-none');
	}

	// handle zero results (no matched filters)
	if(self.matchedItemsCount == 0) {
		self.emptyResultText.removeClass('d-none');
	}
};
